
   
import router from '../router'
import limitJudge from '@/util/includes'
const logout = () =>{
    localStorage.removeItem('token')
    localStorage.removeItem('userInfo')
    router.push('/login')
}
 export default logout